<!-- <div id="{{ targetId }}" class="map"  style="width: 100%; height: 100%; position: fixed;"></div> -->

<div class="map-layout-container">
    <div class="toolbar-spacer"></div>
    <!-- <div class="map-pane"> -->
        <div #ttMap targetId="'ttMap'" id="map" class="map"></div>
    <!-- </div> -->
</div>
<!-- <div id="map" class="map"  style="width: 100%; height: 100%; position: absolute;"></div> -->
<!-- <div id="map" class="map"  style="width: 100%; height: 100%; position: absolute;overflow: hidden;"></div> -->
<!-- Popup -->
<!-- TODO: move this div -->
<div id="featureInfoTooltip" class="ol-tooltip"></div>